import { MapPin, ShieldCheck } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export const ProductosPaquete = ({ productos, id }) => (
  <div className="space-y-0.5" data-testid={id}>
    {(productos || []).map((x, i) => (
      <div key={i} className="text-base leading-snug"><b>{x.cantidad}× {x.producto}</b> <span className="text-zinc-600 uppercase">{[x.tamano, x.estilo, x.color].filter(Boolean).join(" · ")}</span></div>
    ))}
  </div>
);

export const CabeceraPaquete = ({ num, de, pedido }) => (
  <div className="flex items-baseline gap-2 flex-wrap">
    <span className="bg-black text-white font-black rounded-md px-2.5 py-0.5 text-xl">PAQUETE {num} de {de}</span>
    <span className="font-black text-xl">– {pedido}</span>
  </div>
);

const permiso = async (guia, onDone) => {
  try { await api.post("/colocacion/permiso", { guia }); toast.success(`Permiso de traslado: guía ${guia}`); onDone?.(); }
  catch (e) { toast.error(formatApiError(e)); }
};

/** Paquete del Organizador sin guía: visible, pero no se puede escanear. */
export const PaqueteSinGuia = ({ r, q, onOpen }) => (
  <button type="button" onClick={onOpen} className="w-full text-left rounded-lg border-2 border-dashed border-red-600 p-4 space-y-1.5 bg-red-50/40" data-testid={`col-singuia-${r.numero}-${q.num}`}>
    <div className="flex justify-between items-start gap-2 flex-wrap">
      <CabeceraPaquete num={q.num} de={q.de} pedido={r.numero} />
      <div className="flex gap-1 flex-wrap">
        {r.prioridad && <span className="bg-red-600 text-white text-xs font-black px-2 py-1 rounded uppercase">Prioridad</span>}
        <span className={`text-sm font-black px-2 py-1 rounded uppercase text-white ${r.empacado ? "bg-emerald-600" : "bg-red-600"}`}>{r.empacado ? "Empacado" : "No empacado"}</span>
      </div>
    </div>
    <div className="text-lg font-bold">{r.cliente}</div>
    {r.destino && <div className="text-sm text-zinc-500 flex gap-1 uppercase"><MapPin className="w-4 h-4 shrink-0" />{r.destino}</div>}
    <ProductosPaquete productos={q.productos} id={`col-singuia-prods-${r.numero}-${q.num}`} />
    <div className="rounded bg-red-600 text-white font-black text-center py-2 text-lg uppercase" data-testid={`col-singuia-aviso-${r.numero}-${q.num}`}>Sin guía · asigne la guía en el Organizador para escanear</div>
    {r.notas && <div className="rounded bg-amber-50 border border-amber-200 p-2 text-sm whitespace-pre-line">{r.notas}</div>}
  </button>
);

/** Cápsula independiente por paquete (Por trasladar). */
export const PaqueteCapsula = ({ r, q, onOpen, onChanged }) => {
  const emp = r.empacado;
  return (
    <div className={`rounded-lg border-2 p-4 space-y-1.5 shadow-sm ${emp ? "border-emerald-600" : "border-red-600"}`} data-testid={`col-capsula-${q.guia}`}>
      <button type="button" onClick={onOpen} className="w-full text-left space-y-1.5">
        <div className="flex justify-between items-start gap-2 flex-wrap">
          <CabeceraPaquete num={q.num} de={q.de} pedido={r.numero} />
          <div className="flex gap-1 flex-wrap">
            {r.prioridad && <span className="bg-red-600 text-white text-xs font-black px-2 py-1 rounded uppercase">Prioridad</span>}
            <span className={`text-sm font-black px-2 py-1 rounded uppercase text-white ${emp ? "bg-emerald-600" : "bg-red-600"}`} data-testid={`col-capsula-empaque-${q.guia}`}>{emp ? "Empacado" : "No empacado"}</span>
          </div>
        </div>
        <div className="text-lg font-bold">{r.cliente}</div>
        {r.destino && <div className="text-sm text-zinc-500 flex gap-1 uppercase"><MapPin className="w-4 h-4 shrink-0" />{r.destino}</div>}
        <ProductosPaquete productos={q.productos} id={`col-capsula-prods-${q.guia}`} />
        {q.sin_organizar && <div className="text-xs font-bold text-amber-700">Sin organizar en el Organizador de Paquetes</div>}
        <div className="flex items-center justify-between gap-2 flex-wrap">
          <span className="bg-black text-white font-mono text-lg font-bold rounded px-2 py-0.5">{q.guia}</span>
          {/[/,;\s]/.test(q.guia) && <span className="text-xs font-black text-red-600 uppercase" data-testid={`col-capsula-multiguia-${q.guia}`}>Varias guías en una: sepárelas en el Organizador</span>}
          <span className="text-xs font-black uppercase px-2 py-1 rounded bg-amber-300">{q.agencia || "Por trasladar"}</span>
        </div>
        {r.notas && <div className="rounded bg-amber-50 border border-amber-200 p-2 text-sm whitespace-pre-line">{r.notas}</div>}
      </button>
      {!emp && (q.permiso
        ? <div className="text-sm font-bold text-[#1D4ED8] flex items-center gap-1" data-testid={`col-capsula-permiso-txt-${q.guia}`}><ShieldCheck className="w-4 h-4" /> Traslado permitido: {q.permiso_txt}</div>
        : <button type="button" onClick={() => permiso(q.guia, onChanged)} className="w-full h-12 rounded-lg bg-[#1D4ED8] text-white font-black uppercase text-lg" data-testid={`col-capsula-permiso-${q.guia}`}>Permiso</button>)}
    </div>
  );
};
